import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import RRoR from "../../../components/UI/RRoR";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import CurrencyNumber from "../../../components/UI/CurrencyNumber";
import PercentageNumber from "../../../components/UI/PercentageNumber";

const ClientProfile = (props) => {
  const { portfolio } = props;
  const { metadata } = portfolio;
  let Clients = portfolio.clientProfiles ?
    portfolio.clientProfiles.map(c => ({profile: c})) :
    portfolio.Clients;
  Clients = Clients.sort((c1, c2) => c1.profile.primary === true && c2.profile.primary === false ? -1 : 1);

  return (
    <section className={"content"}>
      <Grid
        container={true}
        spacing={3}
        className={"content"}
        data-toc={`How Cy Calculates Required Rate of Return`}
      >
        <Grid item={true} xs={12}>
          <Typography variant="h4">
            How Cy Calculates Required Rate of Return
          </Typography>
          <Typography variant="h5">Required Rate of Return</Typography>
          <Typography variant="h6" gutterBottom={true}>
            <RRoR rrorValue={metadata.rror} />
          </Typography>
        </Grid>
        <Grid item={true} xs={6} style={{ paddingTop: 0 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Data and Assumptions</TableCell>
                <TableCell
                  align="right"
                  style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                >
                  {Clients[0].profile.firstName +
                    " " +
                    Clients[0].profile.lastName}
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell
                    align="right"
                    className={`header`}
                    style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                  >
                    {Clients[1].profile.firstName +
                      " " +
                      Clients[1].profile.lastName}
                  </TableCell>
                )}
                <TableCell
                  align="right"
                  style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                >
                  Household (or Defaults)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Client DOB</TableCell>
                <TableCell align="right">{Clients[0].profile.dob}</TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">{Clients[1].profile.dob}</TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Retirement Age</TableCell>
                <TableCell align="right">
                  {Clients[0].profile.retirementAge}
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    {Clients[1].profile.retirementAge}
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Current Annual Income</TableCell>
                <TableCell align="right">
                  <CurrencyNumber value={Clients[0].profile.currentIncome} />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber value={Clients[1].profile.currentIncome} />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Annual Income Increase</TableCell>
                <TableCell align="right">
                  <PercentageNumber
                    value={Clients[0].profile.annualIncomeIncrease}
                  />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <PercentageNumber
                      value={Clients[1].profile.annualIncomeIncrease}
                    />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Current Qualified Plan Assets</TableCell>
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile.currentQualifiedPlans}
                  />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber
                      value={Clients[1].profile.currentQualifiedPlans}
                    />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Current Other Household Investments/Savings
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile.currentNonQualifiedSavings}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Annual Qualified Plan Contributions (Employee + Employer)
                </TableCell>
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile.annualQualifiedPlans}
                  />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber
                      value={Clients[1].profile.annualQualifiedPlans}
                    />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Annual Other Household Investments/Savings
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile.annualNonQualifiedSavings}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Expected Monthly Social Security Income</TableCell>
                <TableCell align="right">
                  <CurrencyNumber value={Clients[0].profile.monthlySSI} />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber value={Clients[1].profile.monthlySSI} />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Expected Monthly Pension Income</TableCell>
                <TableCell align="right">
                  <CurrencyNumber value={Clients[0].profile.monthlyPension} />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber value={Clients[1].profile.monthlyPension} />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Expected Other Annual Income in Retirement
                </TableCell>
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile.otherAnnualIncome}
                  />
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    <CurrencyNumber
                      value={Clients[1].profile.otherAnnualIncome}
                    />
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Number of Years for Expected Other Annual Income
                </TableCell>
                <TableCell align="right">
                  {Clients[0].profile.otherAnnualIncomeYears}
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell align="right">
                    {Clients[1].profile.otherAnnualIncomeYears}
                  </TableCell>
                )}
                <TableCell align="right">--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Annual Expenses Pre-Retirement</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile["combinedAnnualExpenseBR"]}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Annual Expenses in Retirement</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber
                    value={Clients[0].profile["combinedAnnualExpenseIR"]}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid item={true} xs={6} style={{ paddingTop: 0 }}>
          <Table style={{ marginBottom: "0.38in" }}>
            <TableHead>
              <TableRow>
                <TableCell>Data and Assumptions</TableCell>
                <TableCell
                  align="right"
                  style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                >
                  {Clients[0].profile.firstName +
                    " " +
                    Clients[0].profile.lastName}
                </TableCell>
                {Clients.length > 1 && (
                  <TableCell
                    align="right"
                    style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                  >
                    {Clients[1].profile.firstName +
                      " " +
                      Clients[1].profile.lastName}
                  </TableCell>
                )}
                <TableCell
                  align="right"
                  style={{ width: Clients.length > 1 ? "17%" : "25%" }}
                >
                  Household (or Defaults)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  Full Retirement Age (FRA) for Social Security
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  {metadata.advisorConfig["fullRetirementAge"]}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Age at Death</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  {metadata.advisorConfig["ageOfDeath"]}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Inflation Rate</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <PercentageNumber
                    value={metadata.advisorConfig["inflationRate"]}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Effective Tax Rate (Fed + State) before Retirement
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <PercentageNumber
                    value={metadata.advisorConfig["taxRateBR"]}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Effective Tax Rate (Fed + State) in Retirement
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <PercentageNumber
                    value={metadata.advisorConfig["taxRateIR"]}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Effective Tax Rate (Fed + State) for Non-Qualified Asset Gains
                </TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <PercentageNumber
                    value={
                      metadata.advisorConfig["taxRateNonQualifiedAssetGains"]
                    }
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Social Security Wage Base</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber value={metadata.advisorConfig["ssiBase"]} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Social Security Max Benefit at FRA</TableCell>
                <TableCell align="right">--</TableCell>
                {Clients.length > 1 && <TableCell align="right">--</TableCell>}
                <TableCell align="right">
                  <CurrencyNumber
                    value={metadata.advisorConfig["ssiMaxBenefitAtFRA"]}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={12}>
          <Typography className={"disclosure"} variant={"caption"} paragraph>
            Note: This data was collected from client to calculate Require Rate
            of Return.
          </Typography>
        </Grid>
      </Grid>
    </section>
  );
};

export default ClientProfile;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/ClientProfile.jsx